import { render } from "./RecipePageView.vue?vue&type=template&id=4964eb62"
import script from "./RecipePageView.vue?vue&type=script&lang=js"
export * from "./RecipePageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__